<template>
  <div class="container mx-auto">
    <div
      class="font-sans bg-grey-lighter flex flex-col min-h-screen w-full p-2"
    >
      <div class="flex-grow container mx-auto sm:px-4 pt-6 pb-8">
        <div
          class="bg-white border-t border-b sm:border-l sm:border-r sm:rounded shadow-lg mb-6"
        >
          <div class="flex flex-col">
            <div class="">
              <div class="flex font-bold px-12 py-6 border-b">
                <div class="text-xl w-1/5">Od</div>
                <div class="text-xl w-1/5">Do</div>
                <div class="text-xl w-1/5">Typ</div>
                <div class="text-xl w-1/5">Jméno</div>
                <div class="text-xl w-1/5"></div>
              </div>
            </div>
            <div v-for="(reservation, i) in reservations" :key="i">
              <div
                class="flex px-12 py-6"
                :class="{ 'bg-gray-100': i % 2 === 0 }"
              >
                <div class="w-1/5">
                  {{ humanDate(reservation.start) }}
                </div>
                <div class="w-1/5">
                  {{ humanDate(reservation.end) }}
                </div>
                <div class="w-1/5">
                  {{ reservationType(reservation.type) }}
                </div>
                <div class="w-1/5">
                  {{ reservation.name }}
                </div>
                <div class="w-1/5">
                  <div class="flex justify-end">
                    <Link :href="`/admin/upravit-rezervaci/${reservation.id}`">
                      <svg
                        class="fill-current text-gray-800 hover:text-gray-600 inline-block h-6 w-6 mr-3"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path
                          class="primary"
                          d="M4 14a1 1 0 0 1 .3-.7l11-11a1 1 0 0 1 1.4 0l3 3a1 1 0 0 1 0 1.4l-11 11a1 1 0 0 1-.7.3H5a1 1 0 0 1-1-1v-3z"
                        />
                        <rect
                          width="20"
                          height="2"
                          x="2"
                          y="20"
                          class="secondary"
                          rx="1"
                        />
                      </svg>
                    </Link>

                    <svg
                      @click="handleConfirmModal(reservation.id, i)"
                      class="fill-current text-red-500 hover:text-red-700 inline-block h-6 w-6 cursor-pointer"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M5 5h14l-.89 15.12a2 2 0 0 1-2 1.88H7.9a2 2 0 0 1-2-1.88L5 5zm5 5a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1z"
                      />
                      <path
                        d="M8.59 4l1.7-1.7A1 1 0 0 1 11 2h2a1 1 0 0 1 .7.3L15.42 4H19a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2h3.59z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import useConfirm from "../ConfirmDialog/useConfirm";

export default {
  components: {
    Link,
  },

  computed: {
    reservations() {
      return this.$store.getters.confirmedReservations;
    },
  },

  setup() {
    const { show } = useConfirm();

    return {
      show,
    };
  },

  methods: {
    reservationType(val) {
      if (val === "ob") {
        return "Obsazeno";
      }

      return "Rezervováno";
    },

    humanDate(val) {
      return new Date(val).toLocaleDateString("cs-CZ");
    },

    removeReservation(id, index) {
      this.$store.dispatch("removeReservation", { id: id, index: index });
    },

    async handleConfirmModal(reservationId, index) {
      const success = await this.show({
        title: "",
        message: "Chcete opravdu odstranit tuto rezervaci?",
        cancel: "Zrušit",
        confirm: "Odstranit",
      });

      if (success) {
        this.removeReservation(reservationId, index);
      }
    },
  },

  mounted() {
    this.$store.dispatch("getReservations");
  },
};
</script>

<style></style>
